import { FormFieldSet } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';
import { useFormContext } from 'react-hook-form';

import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelectPayerField } from 'src/common/MultiSelectPayerContextField';

import { FormValues } from '../FormValues';

export const PayerMultiLoadSettings = () => {
  const { getValues, watch, setValue } = useFormContext<FormValues>();
  return (
    <div className="py-2">
      <FormFieldSet
        legend="Multi-loading Configuration"
        Fields={
          <>
            <FormFieldController name="can_multiload">
              {({ field }) => {
                return (
                  <FormField
                    colSpan={12}
                    type="switch"
                    label="Enable Multi-loading"
                    inputProps={{
                      value: field.value,
                      onChange: field.onChange,
                      id: 'enable_multi_loading',
                      checked: field.value,
                    }}
                  />
                );
              }}
            </FormFieldController>
            <FormFieldController name="multiloading_partners">
              {({ field }) => {
                const canMultiload = watch('can_multiload');
                const id = getValues('id');

                if (!canMultiload && field.value.length > 0) {
                  setValue('multiloading_partners', []);
                }

                return (
                  <div className="col-span-12">
                    <MultiSelectPayerField
                      fieldPath="multiloading_partners"
                      fieldLabel="Allow multi-loading with"
                      disabled={!canMultiload}
                      selectedPayerId={id || undefined}
                    />
                  </div>
                );
              }}
            </FormFieldController>
          </>
        }
      />
    </div>
  );
};
